import * as WeexDriver from 'driver-weex';
export default WeexDriver;